export default function headGridCss(breakpoints, spacing) {
  return {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 5fr) minmax(0, 7fr)',
    columnGap: spacing(6),
    alignItems: 'start',
    '& > .MSHD-say': {
      maxWidth: '62ch',
      textWrap: 'pretty',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },
    [breakpoints.down('md')]: { gridTemplateColumns: 'minmax(0, 1fr)', rowGap: spacing(2) },
  };
}
